import { useNullValueState } from '../../hooks/useNullValueState';
import { useCallback, useContext, useEffect } from 'react';
import { useTranslationHelpers } from '../../hooks/useTranslationHelpers';
import { getDefaultNullValue, isOperatorIncludesObjectsWithNoValueSet } from 'customer-data-filters-ui/utils/defaultNullValue';
import FormattedMessage from 'I18n/components/FormattedMessage';
import After from 'customer-data-filters-ui/filterQueryFormat/operator/After';
import DefaultNullValueRecord from '../../filterQueryFormat/DefaultNullValueRecord';
import { REMOVE_DEFAULT_VALUE_LOGIC } from '../../permissions/gates';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import { Checkbox } from 'foundations-components/transitional/components/Checkbox';
import { jsx as _jsx } from "react/jsx-runtime";
const EditorIncludeObjectsWithNoValueSetInput = props => {
  const {
    condition,
    filterFamily,
    conditionPath,
    onChange,
    spaceStyleProps
  } = props;
  const {
    getIsUngated
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFieldLabelStringByName
  } = useTranslationHelpers(filterFamily);
  const {
    getShowNoValueCheckbox,
    updateNullValueState
  } = useNullValueState(filterFamily, condition, conditionPath);
  useEffect(() => {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
    updateNullValueState(condition);
  }, [condition, updateNullValueState]);
  const onCheckboxChange = useCallback(evt => {
    const isChecked = evt.target.checked;
    let defaultNullValue;
    if (getIsUngated(REMOVE_DEFAULT_VALUE_LOGIC)) {
      defaultNullValue = DefaultNullValueRecord({
        includeObjectsWithNoValueSet: isChecked
      });
    } else {
      defaultNullValue = isChecked ? getDefaultNullValue(condition, true) : DefaultNullValueRecord();
    }
    onChange(condition.set('defaultNullValue', defaultNullValue));
  }, [onChange, condition, getIsUngated]);

  // @ts-expect-error ts-migrate(2554) FIXME: Expected 0 arguments, but got 1.
  if (!getShowNoValueCheckbox(condition)) {
    return null;
  }
  let unknownFieldLabel = condition.field && condition.field.label;
  if (condition instanceof After) {
    // @ts-expect-error need better/more specific OperatorInstance typing
    unknownFieldLabel = getFieldLabelStringByName(condition.value);
  }
  const isChecked = isOperatorIncludesObjectsWithNoValueSet(condition);
  return /*#__PURE__*/_jsx(Checkbox, Object.assign({}, spaceStyleProps, {
    checked: isChecked,
    onChange: onCheckboxChange,
    size: "small",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.includeObjectsWithNoValueSet",
      options: {
        label: unknownFieldLabel
      }
    })
  }));
};
export default EditorIncludeObjectsWithNoValueSetInput;